<template>
  <div class="patient-data-table">
      <table class="mdc-data-table__table patient-table">
        <thead>
          <tr class="mdc-data-table__header-row">
            <th class="mdc-data-table__header-cell">{{transcriptColumnTitle('id_patient')}}</th>
            <th class="mdc-data-table__header-cell">{{transcriptColumnTitle('n_docs')}}</th>
            <th class="mdc-data-table__header-cell">{{transcriptColumnTitle('name_osmotr')}}</th>
            <th class="mdc-data-table__header-cell">{{transcriptColumnTitle('branch')}}</th>
            <th class="mdc-data-table__header-cell">{{transcriptColumnTitle('datebegin')}}</th>
            <th class="mdc-data-table__header-cell">{{transcriptColumnTitle('login_add')}}</th>
            <th class="mdc-data-table__header-cell">{{transcriptColumnTitle('status')}}</th>
            <th class="mdc-data-table__header-cell"></th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="item in items"
            :key="item.main.id_patient">
            <tr
              :class="['mdc-data-table__row',
                'mdc-data-table__row_clickable',
                {row_active: item.main.id_patient === expanded}]"
              @click="expand(item.main.id_patient)">
              <td class="mdc-data-table__cell">
                {{ item.main.id_patient }}
              </td>
              <td class="table__cell">
                <PatientDocList
                  :patientData="item.main"
                  @refresh="checkDocStatus"
                  @closeOthers="closeMenus"
                  ref="docLists"
                />
              </td>
              <td class="mdc-data-table__cell">
                {{ item.main.name_osmotr }}
              </td>
              <td class="mdc-data-table__cell">
                {{ item.main.branch }}
              </td>
              <td class="mdc-data-table__cell">
                {{ item.main.datebegin }}
              </td>
              <td class="mdc-data-table__cell">
                {{ item.main.login_add }}
              </td>
              <td class="mdc-data-table__cell flex">
                <span v-if='showCancelConfirm !== item.main.id_patient'>{{ item.main.status }}</span>
                <section v-if='item.main.status === "В ожидании"' class='inline-flex'>
                  <mcw-material-icon
                    v-if='showCancelConfirm !== item.main.id_patient'
                    class="icon-warning on-left pointer"
                    icon="block"
                    title="Отменить визит?"
                    @click.stop='showCancelConfirm = item.main.id_patient;'>
                  </mcw-material-icon>
                  <InlineConfirmation
                    v-else
                    question='Отменить визит?'
                    @confirm="handleConfirm(item.main)"
                    @cancel="showCancelConfirm = null;"
                  />
                </section>
              </td>
              <td class="mdc-data-table__cell">
                {{ item.main.conclusion_date }}
              </td>
              <td class="mdc-data-table__cell">
                {{ getServicesSum(item.main.services) }}
              </td>
              <td v-if='userRank >= 100' class="mdc-data-table__cell">
                <mcw-button
                  class="all-patient-table-btn"
                  @click.stop="openPatientReportModal(item)">
                  <mcw-material-icon icon="connect_without_contact" /> Стучалка
                </mcw-button>
              </td>
            </tr>
            <tr v-if="item.main.id_patient === expanded && !updating">
              <td colspan="9">
                <mcw-layout-grid>
                  <mcw-layout-cell desktop="6" phone="12" align="top">
                    <AddFieldsTable :items="item.add" />
                  </mcw-layout-cell>
                  <mcw-layout-cell desktop="6" phone="12" align="top">
                    <ServicesTable
                      :services="item.add.services ?? '[]'"
                      :patient='item'
                      @updateServices="handleServicesUpdate(item.main)" />
                  </mcw-layout-cell>
                </mcw-layout-grid>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    <mcw-dialog
      v-model="showPatientNotesModal"
      escape-key-action="close">
      <mcw-dialog-title>
        Стучалка
        <mcw-icon-button class="btn_close" @click="showPatientNotesModal = false">
          <mcw-material-icon icon="close"/>
        </mcw-icon-button>
      </mcw-dialog-title>
      <mcw-dialog-content>
        <StuchalkaPopup
          ref="stuchalka"
          :selected-patient="patient"
          :selected-status-bar="patientInfo"
          @close="showPatientNotesModal = false"
          @send-report="handleSendReport"
        />
      </mcw-dialog-content>
    </mcw-dialog>
  </div>
</template>

<script>
import PatientDocList from './PatientDocList.vue';
import ServicesTable from './ServicesTable.vue';
import AddFieldsTable from './AddFieldsTable.vue';
import InlineConfirmation from './InlineConfirmation.vue';
import StuchalkaPopup from './StuchalkaPopup.vue';
import { transcriptColumnTitle } from '../helpers/transcriptor';

export default {
  name: 'PatientDataTable',
  emits: [
    'showDocs', 'update', 'selectPatient',
  ],
  props: {
    patient: Object,
    items: Array,
  },
  components: {
    PatientDocList,
    ServicesTable,
    AddFieldsTable,
    InlineConfirmation,
    StuchalkaPopup,
  },
  data() {
    return {
      expanded: null,
      isSendVisible: false,
      doc: null,
      addFields: false,
      showCancelConfirm: false,
      patientInfo: null,
      showPatientNotesModal: false,
      selectedPatient: null,
      updating: false,
    };
  },
  methods: {
    checkDocStatus() {
      this.emitter.emit('checkDocStatus', (this.patient, true));
    },
    expand(id) {
      if (id === this.expanded) {
        this.expanded = null;
        return false;
      }
      this.expanded = id;
      this.$emit('selectPatient', id);
    },
    getServicesSum(services) {
      if (!services) {
        return '';
      }
      const arr = JSON.parse(services);
      // eslint-disable-next-line no-return-assign
      return arr.reduce(((acc, item) => acc += Number(item.price)), 0);
    },
    transcriptColumnTitle(column) {
      return transcriptColumnTitle(column);
    },
    // expandAddFields(index) {
    //   const selectedVisit = this.items[index].add;
    //   this.addFields = !this.addFields;
    // },
    closeMenus(id) {
      this.emitter.emit('closeDocLists', id);
    },
    async openPatientReportModal(item) {
      this.selectedPatient = item.main;
      [this.patientInfo] = await this.$store.dispatch('employeesData/getPatientNotes', this.selectedPatient.id_patient)
      ?? [{ nastuchat: null, balance: 0 }];
      this.showPatientNotesModal = true;
    },
    async handleSendReport(context) {
      const params = {
        id_patient: this.selectedPatient.id_patient,
        text: context.text,
        send_email: context.notifyAdmin ? 1 : 0,
      };
      [this.patientInfo] = await this.$store.dispatch('employeesData/sendPatientNote', params) ?? [{ nastuchat: null, balance: 0 }];
      this.$refs.stuchalka.clear();
      this.selectedPatient = null;
    },
    async handleConfirm(patient) {
      const params = {
        id_patient: patient.id_patient,
      };
      try {
        const res = await this.$store.dispatch('employeesData/cancelPatient', params);
        if (res) {
          this.$emit('update', patient);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.showCancelConfirm = false;
      }
    },
    rerender() {
      this.updating = true;
      this.$nextTick(() => {
        this.updating = false;
      });
    },
    async handleServicesUpdate(patient) {
      this.$emit('update', patient);
    },
  },
  computed: {
    userRank() {
      return this.$store.getters['user/getUserRank'];
    },
  },
};
</script>

<style lang="scss">
@use '@material/tooltip/styles';
@use "@material/data-table/mdc-data-table";
.patient-data-table {
  border: 2px solid var(--mdc-theme-primary);
  padding: 0 5px;
}
.patient-data-table .mdc-dialog__content {
  // overflow-y: auto;
  // height: calc(100vh - 124px);
}
.patient-table {
  &__close-btn{
    right: 0!important;
    top: 0!important;
    --mdc-ripple-left: 10px!important;
    --mdc-ripple-top: 10px!important;
  }
  &__close-btn:hover{
    --mdc-ripple-left: 10px!important;
    --mdc-ripple-top: 10px!important;
  }
  &__conclusion{
    max-width: 200px;
    white-space: break-spaces;
  }
}
.row_expandable{
  cursor: pointer;
}
.row_active{
  cursor: pointer;
  background-color: rgba($color: #000000, $alpha: 0.08);
}
.pointer {
  cursor: pointer;
}
.mdc-dialog__content{
  overflow: initial;
}
.inline-flex {
  display: inline-flex;
}
.on-left {
  margin-left: 0.25rem;
}
.icon-warning {
  color: #ea8b25 !important;
}
.flex {
  display: flex;
  align-items: center;
}
</style>
